export default {
    methods: {
        getDocumentUrl(documentId) {
            const apiUrl = this.$store.state.application.apiRootUrl;
            return `${apiUrl}/documents/${documentId}`;
        }
    }
};
